import { useEffect, useRef, useState } from "react";
import "./StatusBar.css";

const stats = [
  { value: "100+", label: "Projects Delivered" },
  { value: "98%",  label: "Happy Clients"       },
  { value: "3",    label: "Currently Running"   },
  { value: "PAN",  label: "India Served"        },
];

/* ── Count-up hook ── */
function useCountUp(target, isVisible, delay = 0, duration = 1800) {
  const [display, setDisplay] = useState("0");

  useEffect(() => {
    if (!isVisible) return;
    const timer = setTimeout(() => {
      const match = String(target).match(/^(\d+)(.*)/);
      if (!match) { setDisplay(target); return; }

      const end    = parseInt(match[1], 10);
      const suffix = match[2];
      const steps  = duration / 16;
      let   cur    = 0;

      const interval = setInterval(() => {
        cur += end / steps;
        if (cur >= end) {
          setDisplay(`${end}${suffix}`);
          clearInterval(interval);
        } else {
          setDisplay(`${Math.floor(cur)}${suffix}`);
        }
      }, 16);

      return () => clearInterval(interval);
    }, delay);

    return () => clearTimeout(timer);
  }, [isVisible, target, delay, duration]);

  return display;
}

/* ── Individual stat card ── */
function StatCard({ stat, visible, index }) {
  const counted = useCountUp(stat.value, visible, index * 180, 1600);

  return (
    <div
      className={`stats-bar__item ${visible ? "stats-bar__item--visible" : ""}`}
      style={{ transitionDelay: `${index * 0.13}s` }}
    >
      <span className="stats-bar__corner stats-bar__corner--tl" />
      <span className="stats-bar__corner stats-bar__corner--tr" />
      <span className="stats-bar__corner stats-bar__corner--bl" />
      <span className="stats-bar__corner stats-bar__corner--br" />

      <span className="stats-bar__icon">◆</span>
      <span className="stats-bar__value">{counted}</span>
      <span className="stats-bar__divider" />
      <span className="stats-bar__label">{stat.label}</span>
    </div>
  );
}

export default function StatsBar() {
  const ref                   = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.2 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="stats-bar" ref={ref}>

      {/* Section heading */}
      <div className={`stats-bar__heading ${visible ? "stats-bar__heading--visible" : ""}`}>
        <div className="stats-bar__heading-tag">Our Numbers</div>
        <h3>Trusted by Clients Across <em>India</em></h3>
      </div>

      {/* Cards */}
      <div className="stats-bar__inner">
        {stats.map((s, i) => (
          <StatCard key={i} stat={s} visible={visible} index={i} />
        ))}
      </div>

      {/* Footer ornament */}
      <div className={`stats-bar__foot ${visible ? "stats-bar__foot--visible" : ""}`}>
        <span className="stats-bar__foot-line" />
        <span className="stats-bar__foot-text">Garvaana Enterprise</span>
        <span className="stats-bar__foot-line" />
      </div>

    </section>
  );
}